import * as React from 'react';

import EndOperation from '../../modules/end-operation';

const EndOperationScreen = () => {
    return <EndOperation />;
};

export default EndOperationScreen;
